import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'Are these freshwater boats?',
    answer: 'Yes. All boats are used exclusively on Lake George, which helps reduce corrosion and long-term wear compared to saltwater vessels.'
  }, {
    question: 'Can I review maintenance records before purchasing?',
    answer: 'Yes. Maintenance documentation is available upon request for each boat.'
  }, {
    question: 'Can I inspect a boat in person before buying?',
    answer: 'Absolutely. Contact us to schedule a viewing.'
  }, {
    question: 'Why choose a fleet-maintained boat?',
    answer: 'Fleet boats follow a consistent preventative service schedule handled by trained technicians, helping support reliability and performance.'
  }, {
    question: 'Does inventory change throughout the season?',
    answer: 'Yes. Available boats rotate regularly, so we recommend reaching out for current availability.'
  }, {
    question: 'Do the boats come with a warranty?',
    answer: 'Yes. All Mercury boat motors include a three-year transferable warranty. Additional extended warranty options are available.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 md:px-12 bg-cream" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-16">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl shadow-sm border border-navy-100 overflow-hidden transition-all duration-200" data-id="element-18">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-19">
                <span className="font-heading font-semibold text-navy text-lg pr-8" data-id="element-20">
                  {faq.question}
                </span>
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${openIndex === idx ? 'bg-copper text-white' : 'bg-navy-50 text-navy-400'}`} data-id="element-21">
                  {openIndex === idx ? <ChevronUp className="w-5 h-5" data-id="element-22" /> : <ChevronDown className="w-5 h-5" data-id="element-23" />}
                </div>
              </button>

              {openIndex === idx && <div className="px-6 pb-6 text-navy-600 leading-relaxed animate-in slide-in-from-top-2 duration-200" data-id="element-24">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}